// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i0-0";
export var animationContainer = "_i0-1";
export var itemPrice = "_i0-a";
export var itemizedContent = "_i0-9";
export var itemizedHeader = "_i0-7";
export var itemizedRow = "_i0-8";
export var itemizedSection = "_i0-6";
export var modalContent = "_i0-2";
export var orderName = "_i0-3";
export var refundOption = "_i0-4";
export var refundOptionsContainer = "_i0-5";
export var shippingLabel = "_i0-b";
export var totalRow = "_i0-c";